import React from "react";

const TimeLunch = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M23.145 33.999c-.268-.28-.542-.553-.801-.841a.494.494 0 01-.13-.295c-.006-3.525-.005-7.051-.004-10.577 0-.026.005-.053.012-.1h8.309v2.76h3.49v.303c0 1.063-.005 2.125.002 3.187.006.847-.336 1.495-1.019 1.959-.766.52-1.536 1.036-2.296 1.567-.087.06-.177.216-.163.312.081.56-.11.978-.543 1.31-.15.116-.27.276-.403.416l-6.454-.001zm9.314-7.425h-1.911v3.558c.598-.407 1.172-.785 1.727-1.19.1-.074.172-.259.176-.394.019-.65.008-1.3.008-1.974z"
            fill={fill}
        />
        <path className="u_fill"
            d="M16.327 2c.572.086 1.146.156 1.712.261 5.305.99 9.696 5.478 10.586 10.795.335 1.997.27 3.971-.264 5.927-.023.082-.052.164-.08.249h-2.493c1.289-4.177.657-7.977-2.292-11.245-2.157-2.392-4.917-3.572-8.144-3.555-6.37.032-11.418 5.514-10.906 11.815.183 2.257.966 4.283 2.382 6.05 1.423 1.777 3.226 3.005 5.404 3.67 2.165.661 4.334.623 6.514-.023v2.501c-1.1.29-2.214.425-3.346.415-6.143-.051-11.343-4.06-12.944-10.003-.198-.736-.268-1.506-.399-2.26-.015-.085-.038-.168-.057-.253V14.5c.048-.355.092-.711.145-1.066C2.952 8.002 7.06 3.57 12.452 2.34c.69-.157 1.4-.229 2.1-.34h1.775z"
            fill={fill}
        />
        <path className="u_fill"
            d="M6.481 16.423h1.92v-1.965h-1.91c.214-3.857 3.712-7.653 7.93-7.975v1.922h1.977V6.5c3.284.136 7.466 3.087 7.985 7.939h-1.938v1.971h1.946a8.155 8.155 0 01-.722 2.683c-.04.085-.225.144-.343.145-1.37.01-2.738.006-4.107.006h-.385v4.637l-2.422.593v-2.008h-1.976v1.928c-4.249-.37-7.689-4.064-7.955-7.971zm12.13.673c-.675-.492-1.306-.962-1.95-1.414-.19-.133-.268-.273-.266-.509.011-1.456.005-2.913.005-4.37v-.348h-1.97c0 1.978-.003 3.927.008 5.876.001.102.104.233.196.302.658.491 1.324.97 1.988 1.452.271.197.545.392.833.6.393-.538.764-1.05 1.156-1.589z"
            fill={fill}
        />
    </svg>
);

export default TimeLunch;
